/*
    © 2021 EcomGraduates
*/

// Quantity change
window.initCartQty = () => {
    document.querySelectorAll('.cart-qty').forEach((el) => {
        el.addEventListener('change', () => {
            console.log('change')
            fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: el.dataset.lineItemKey,
                    quantity: el.value
                })
            })
                .then((response) => response.json())
                .then((data) => {
                    console.log(data)

                    document.querySelectorAll('.cart-items-count').forEach((el2) => {
                        el2.textContent = data.item_count
                    })

                    fetch(window.location.href)
                        .then((response) => response.text())
                        .then((data2) => {
                            const parser = new DOMParser()
                            const newDocument = parser.parseFromString(data2, 'text/html')
                            document.querySelector('#offcanvas-cart-inner')?.replaceWith(newDocument.querySelector('#offcanvas-cart-inner'))
                            document.querySelector('#cart-page')?.replaceWith(newDocument.querySelector('#cart-page'))
                            if (data.items.length === 0) {
                                setTimeout(() => {
                                    const offcanvas = bootstrap.Offcanvas.getInstance(document.querySelector('#offcanvas-cart'))
                                    offcanvas.hide()
                                }, 500)
                            }
                            window.initCartQty()
                        })
                })
        })
    })
}
window.initCartQty();

// Summary sticky top layout
(() => {
    const cartSummary = document.querySelector('#cart-summary.sticky-top')
    if (cartSummary) {
        const navbarHeight = document.querySelector('#shopify-section-navbar.sticky-top').clientHeight
        cartSummary.style.top = navbarHeight + 20 + 'px'
        cartSummary.style.zIndex = '1019'
    }
})()


// Cart upsells on offcanvas cart modal
window.initCartOffcanvasUpsells = async () => {
    const modal = document.querySelector('#offcanvas-cart')
    const {
        upsellsEnabled,
        upsellsTitle,
        upsellsLimitProducts,
        upsellsCollectionHandle,
        textAddToCartShort
    } = modal.dataset

    if (upsellsEnabled === 'false') {
        return
    }

    const productsResponse = await fetch(`/collections/${upsellsCollectionHandle}/products.json`)
    const productsData = await productsResponse.json()
    // console.log(productsData);

    const cartResponse = await fetch('/cart.json')
    const cartData = await cartResponse.json()
    // console.log(cartData);

    let products = []

    products = productsData.products.filter(
        (product) => product.variants.some(
            (variant) => variant.available
        )
    )

    products = products.filter(
        (product) => cartData.items.some(
            (item) => item.product_title.includes(product.title)
        ) === false
    )

    products = products.sort(() => 0.5 - Math.random())

    products = products.slice(0, upsellsLimitProducts)

    // console.log(products);

    let upsellsListItems = ''

    products.forEach((product) => {
        const variantOptions = product.variants.map(
            (variant) => `
                <option 
                    value="${variant.id}"
                    ${!variant.available ? 'disabled' : ''}>
                    ${variant.title} - ${window.formatMoney(variant.price)}
                </option>`
        )

        upsellsListItems += `
            <li class="cart-upsells-list-item py-1">
                <form method="post" action="/cart/add" id="product_form_${product.id}" class="shopify-product-form offcanvas-cart-upsells-form">
                    <div class="row mx-n2 align-items-center">
                        <div class="col-3 px-2">
                            <a href="/products/${product.handle}" class="">
                                <img 
                                    class="img-fluid img-thumbnail"
                                    src="${window.resizeImage(product.images[0].src, '240x240_crop_center')}"
                                    alt="" 
                                    width="240"
                                    height="240">
                            </a>
                        </div>
                        <div class="col-6 px-2">
                            <h3 class="h6 mb-2">
                                <a href="/products/${product.handle}" class="text-decoration-none">
                                    ${product.title}
                                </a>
                            </h3>
                            <p class="price-final mb-0 ${product.variants.length > 1 ? 'd-none' : ''}">
                                ${window.formatMoney(product.variants[0].price)}
                            </p>
                            <select name="id" class="form-select form-select-sm ${product.variants.length === 1 ? 'd-none' : ''}" aria-label="Select variant">
                                ${variantOptions}
                            </select>
                        </div>
                        <div class="col-3 px-2 text-center">
                            <button 
                                type="submit" 
                                class="btn btn-atc btn-primary btn-sm text-uppercase visible">
                                ${textAddToCartShort}
                            </button>
                        </div>
                    </div>
                </form>
            </li>
        `
    })

    const upsellsWrapper = `
        <div id="cart-upsells-wrapper" class="px-0 mt-6 mb-2 ${products.length === 0 ? 'd-none' : ''}">
            <h4 class="offcanvas-cart-upsells-title bg-light py-3 px-4 h6 small text-cursive text-center mb-4">
                ${upsellsTitle}
            </h4>
            <ul class="cart-upsells-list list-unstyled">
                ${upsellsListItems}
            </ul>
        </div>
    `

    document.querySelector('#offcanvas-cart .offcanvas-body')
        .insertAdjacentHTML('beforeend', upsellsWrapper)

    window.initAtcAjaxForms()
}

document.querySelector('#offcanvas-cart')
    .addEventListener('show.bs.offcanvas', () => {
        if (!document.querySelector('#cart-upsells-wrapper')) {
            window.initCartOffcanvasUpsells()
        }
    })
